import { getCurrentPageName, getPageLoadNumber } from '@ms/yammer-telemetry-support';

import type { TelemetryEvent } from '../../events';
import { isAnalyticsV2Event } from '../../events';

const hasValue = <T>(value: T): value is NonNullable<T> => value != null;

export const addPageLoadFieldsToLogEventIfNotAlreadyPresent = async (
  event: TelemetryEvent
): Promise<TelemetryEvent> => {
  if (isAnalyticsV2Event(event)) {
    return event;
  }

  return {
    ...event,
    properties: {
      ...event.properties,
      page: hasValue(event.properties.page) ? event.properties.page : getCurrentPageName(),
      pageLoadNumber: hasValue(event.properties.pageLoadNumber) ? event.properties.pageLoadNumber : getPageLoadNumber(),
    },
  };
};
